import React, { useState } from "react";

type MenuItem = {
  id: number;
  name: string;
  price: number;
  img: string | null;
  description?: string | null;
};
type MenuInput = {
  id: number;
  name: string;
  price: number;
  img: File | null;
  description: string;
};

type MenuEditModalProps = {
  menu: MenuItem;
  onClose: () => void;
  onSave: (updatedMenu: MenuInput, imgFile?: File) => void;
};

const MenuEditModal: React.FC<MenuEditModalProps> = ({
  menu,
  onClose,
  onSave,
}) => {
  const [name, setName] = useState(menu.name);
  const [price, setPrice] = useState<number | "">(menu.price);
  const [description, setDescription] = useState(menu.description || "");
  const [imgPreview] = useState(menu.img); // 이미지 미리보기
  const [imgFile, setImgFile] = useState<File | null>(null); // 실제 파일

  const handleSubmit = () => {
    if (!name || !price) {
      alert("이름과 가격을 입력해 주세요.");
      return;
    }

    const updatedMenu: MenuInput = {
      ...menu,
      name,
      price: Number(price),
      img: imgFile,
      description,
    };
    onSave(updatedMenu);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImgFile(file);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-md max-h-[90vh] flex flex-col shadow-lg">
        {/* 헤더 - 고정 */}
        <div className="p-6 pb-4 border-b flex-shrink-0">
          <h2 className="text-xl font-semibold">메뉴 수정</h2>
        </div>

        {/* 스크롤 가능한 컨텐츠 영역 */}
        <div className="overflow-y-auto flex-1 p-6 pt-4 custom-scrollbar">
          <div className="mb-4">
            <label className="block text-2xl font-medium text-gray-700">
              이름
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div className="mb-4">
            <label className="block text-2xl font-medium text-gray-700">
              가격
            </label>
            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(Number(e.target.value))}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div className="mb-4">
            <label className="block text-2xl font-medium text-gray-700">
              이미지
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          {imgPreview && (
            <div className="mb-4">
              <label className="block text-2xl font-medium text-gray-700">
                현재 이미지
              </label>
              <img
                src={imgPreview}
                alt="미리보기"
                className="h-40 w-full object-cover rounded-md mb-2"
              />
            </div>
          )}

          <div className="mb-4">
            <label className="block text-2xl font-medium text-gray-700">
              설명 (선택)
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full border px-3 py-2 rounded"
              placeholder="메뉴 설명을 입력하세요"
              rows={3}
            />
          </div>
        </div>

        {/* 버튼 영역 - 고정 */}
        <div className="p-6 pt-4 border-t flex justify-end space-x-2 flex-shrink-0">
          <button
            onClick={onClose}
            className="text-2xl px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            취소
          </button>
          <button
            onClick={handleSubmit}
            className="text-2xl px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            저장
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuEditModal;
